import './PitchesPerCountChart.scss';

import { ChartProps } from 'utilities/chartIdToComponent';
import { PitchesPerCountChartConfigDto, PitchesPerCountChartDto } from 'types/CodegenReportTypes';
import { pitchTypeGroupToColor, pitchTypeToColor } from 'utilities/colorHelpers';
import CountChart, { CountChartData, counts } from 'components/CountChart/CountChart';
import Legend from 'components/Legend/Legend';
import { useMemo } from 'react';
import useReportStore from 'hooks/PlayerReport/Pitcher/reportStore';
import { pitchTypeGroupLegendItems, pitchTypeGroups, pitchTypeLegendItems, pitchTypes } from 'utilities/constants';

const PitchesPerCountChart = ({ chartData, isLoading }: ChartProps<PitchesPerCountChartDto, PitchesPerCountChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  const countChartData = useMemo(
    () =>
      counts.reduce((map, count) => {
        const pitchTypeUsage = chartData?.pitchTypePerCountList.find((x) => x.count === count)?.pitchTypeUsage ?? [];
        map.set(
          count,
          pitchTypeUsage.map((pitchTypeUsage) => ({
            value: pitchTypeUsage.usage,
            color:
              selectedConfgValues.pitchGrouping === 'Types'
                ? pitchTypeToColor[pitchTypeUsage.pitchGroupOrType]
                : pitchTypeGroupToColor[pitchTypeUsage.pitchGroupOrType],
          }))
        );
        return map;
      }, new Map() as CountChartData),
    [chartData]
  );

  const pitchTypesInData = useMemo(
    () =>
      Array.from(
        new Set(
          chartData?.pitchTypePerCountList
            .map((x) => x.pitchTypeUsage)
            .flat()
            .map((x) => x.pitchGroupOrType)
        )
      ) ?? [],
    [chartData]
  );

  const filteredLegendItems = useMemo(
    () =>
      (selectedConfgValues.pitchGrouping === 'Types' ? pitchTypeLegendItems : pitchTypeGroupLegendItems).filter((item) =>
        pitchTypesInData.includes(item.label)
      ),
    [pitchTypesInData]
  );

  return (
    <div className='PitchesPerCountChart-container'>
      <CountChart
        chartData={countChartData}
        isLoading={isLoading}
        colorsToSimulate={
          selectedConfgValues.pitchGrouping === 'Types'
            ? pitchTypes.filter((x) => x !== 'Undefined').map((x) => pitchTypeToColor[x])
            : pitchTypeGroups.filter((x) => x !== 'Undefined').map((x) => pitchTypeGroupToColor[x])
        }
      />
      <Legend items={filteredLegendItems} />
    </div>
  );
};

export default PitchesPerCountChart;
